import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import CreateSplitSheetPage from './pages/CreateSplitSheetPage';
import CreateSplitSheetSA from './pages/CreateSplitSheetSA';
import SplitSheetDetailPage from './pages/SplitSheetDetailPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen bg-gray-50">
          <Navbar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
                <Route
                  path="/split-sheets/new"
                  element={
                    <ProtectedRoute>
                      <CreateSplitSheetPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/split-sheets/new-sa"
                  element={
                    <ProtectedRoute>
                      <CreateSplitSheetSA />
                    </ProtectedRoute>
                  }
                />
            <Route
              path="/split-sheets/:id"
              element={
                <ProtectedRoute>
                  <SplitSheetDetailPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
        <Analytics />
        <SpeedInsights />
      </AuthProvider>
    </Router>
  );
}

export default App;
